import { render } from "./ModalHiddenStep.vue?vue&type=template&id=52550858"
const script = {}

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__